import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import { 
  EXTERNAL_REVIEW_DETAIL,
  EXTERNAL_REVIEW_SEARCH,
  EXTERNAL_REVIEW_ADD,
  EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST,
  EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST,
  EXTERNAL_REVIEW_LIST,
  EXTERNAL_REVIEW_UPDATE,
} from '../actions';

import {
  ExternalReviewDetailSuccess,
  ExternalReviewDetailError,
  ExternalReviewSearchSuccess,
  ExternalReviewSearchError,
  ExternalReviewAddSuccess,
  ExternalReviewAddError,
  ExternalReviewSearchExternalReviewStateListSuccess,
  ExternalReviewSearchExternalReviewStateListError,
  ExternalReviewSearchSupplierListSuccess,
  ExternalReviewSearchSupplierListError,
  ExternalReviewListSuccess,
  ExternalReviewListError,
  ExternalReviewUpdateSuccess,
  ExternalReviewUpdateError,
} from '../actions';

export function* watchExternalReviewDetail() {
  yield takeEvery(EXTERNAL_REVIEW_DETAIL, onExternalReviewDetail);
}

export function* watchExternalReviewSearch() {
  yield takeEvery(EXTERNAL_REVIEW_SEARCH, onExternalReviewSearch);
}

export function* watchExternalReviewAdd() {
  yield takeEvery(EXTERNAL_REVIEW_ADD, onExternalReviewAdd);
}

export function* watchExternalReviewSearchExternalReviewStateList() {
  yield takeEvery(EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST, onExternalReviewSearchExternalReviewStateList);
}

export function* watchExternalReviewSearchSupplierList() {
  yield takeEvery(EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST, onExternalReviewSearchSupplierList);
}

export function* watchExternalReviewList() {
  yield takeEvery(EXTERNAL_REVIEW_LIST, onExternalReviewList);
}

export function* watchExternalReviewUpdate() {
  yield takeEvery(EXTERNAL_REVIEW_UPDATE, onExternalReviewUpdate);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onExternalReviewDetailAsync  = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'external_review/get', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onExternalReviewSearchAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'external_review/search', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

const onExternalReviewAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'external_review/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

const onExternalReviewSearchExternalReviewStateListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/external_review_state', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onExternalReviewSearchSupplierListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/supplier', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onExternalReviewListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'external_review/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onExternalReviewUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'external_review/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

function* onExternalReviewSearch(data) {
  try {
    const response = yield call(onExternalReviewSearchAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(ExternalReviewSearchSuccess(response.data.data));
  } catch (error) {
    console.log('catch error', error)
    yield put(ExternalReviewSearchError(error));
  }
}

function* onExternalReviewAdd(data) {
  try {
    const response = yield call(onExternalReviewAddAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(ExternalReviewAddSuccess(response.data.data));
  } catch (error) {
    console.log('catch error', error)
    yield put(ExternalReviewAddError(error));
  }
}

function* onExternalReviewDetail(data) {
  try {
    const response = yield call(onExternalReviewDetailAsync, data);
    yield put(ExternalReviewDetailSuccess(response.data.data));
  } catch (error) {
    yield put(ExternalReviewDetailError(error));
  }
}

function* onExternalReviewSearchExternalReviewStateList(data) {
  try {
    const response = yield call(onExternalReviewSearchExternalReviewStateListAsync, data);
    yield put(ExternalReviewSearchExternalReviewStateListSuccess(response.data));
  } catch (error) {
    yield put(ExternalReviewSearchExternalReviewStateListError(error));
  }
}

function* onExternalReviewSearchSupplierList(data) {
  try {
    const response = yield call(onExternalReviewSearchSupplierListAsync, data);
    yield put(ExternalReviewSearchSupplierListSuccess(response.data));
  } catch (error) {
    yield put(ExternalReviewSearchSupplierListError(error));
  }
}

function* onExternalReviewList(data) {
  try {
    const response = yield call(onExternalReviewListAsync, data.payload);
    yield put(ExternalReviewListSuccess(response.data));
  } catch (error) {
    yield put(ExternalReviewListError(error));
  }
}

function* onExternalReviewUpdate(data) {
  try {
    const response = yield call(onExternalReviewUpdateAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(ExternalReviewUpdateSuccess(response.data));
  } catch (error) {
    yield put(ExternalReviewUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchExternalReviewDetail),
    fork(watchExternalReviewSearch),
    fork(watchExternalReviewSearchExternalReviewStateList),
    fork(watchExternalReviewSearchSupplierList),
    fork(watchExternalReviewList),
    fork(watchExternalReviewAdd),
    fork(watchExternalReviewUpdate),
  ]);
}